import EditUserAccountsPage from "../components/editUser/EditUserAccountsPage";
import { type EditUserAccountsDTO } from "../EditUserAccountDTO";
import { transformData } from "~/UserAccounts/transformers/UserAccountsTransformer";

export function create(data: EditUserAccountsDTO) {
  return <EditUserAccountsPage {...transformData(data)} />;
}
